import axios from 'axios'

import { store } from '../store'

import { getUid } from './auth'

import {router} from '@/router'

const $http = axios.create({
    // baseURL:process.env.VUE_APP_BASE_API,
    timeout:10000
});

//请求拦截
$http.interceptors.request.use(config=>{
    let uid=getUid() || store.getters.uid || null;
    // uid=9;//测试

    let getParams=config.params || {};
    let postData=config.data || {};
    if(config.method == 'get'){
        config.params=Object.assign(getParams,{userId:uid});
    }else if(config.method == 'post'){
        config.data=Object.assign(postData,{userId:uid});
    }
    return config
},error=>{
    console.log(`req-inteceptor error ${error}`);
    Promise.reject(error);
});
//响应拦截
$http.interceptors.response.use(response=>{
    
    return response.data;
},error=>{
    return Promise.reject(error);
});

export default $http;